module.exports = __webpack_public_path__ + "static/media/SoccerQvizz.750126ce.png";